export default __webpack_public_path__ + "static/media/snow.74898fa0.mp4";